import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../../assets/styles/tokens";

type StatusColor = "success" | "warning" | "error";

interface BLDWebsitePerformanceCardProps {
  date: string;
  cac: string;
  cpaPV: string;
  qftd: string;
  ClickIn: string;
  roiPercentage: string;
  roiColor: StatusColor;
  rs: string;
}

export function BLDWebsitePerformanceCard({
  date,
  cac,
  cpaPV,
  qftd,
  ClickIn,
  roiPercentage,
  roiColor,
  rs,
}: BLDWebsitePerformanceCardProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: "0px 1px 2px #0A0D120F , 0px 1px 3px #0A0D121A",
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.none.$value,
          mt: spacing.Spacing.xl.$value + "!important",
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontSize: typography.Size.Text.xs.$value,
              m: 0,
            }}
          >
            {date}
          </Typography>
        </Stack>

        <Stack
          sx={{ mb: spacing.Spacing.xs.$value, mt: spacing.Spacing.xs.$value }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: typography.Size.Text.sm.$value,
              color: colors.GrayLightMode[900].$value,
            }}
          >
            CAC
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                ml: spacing.Spacing.xs.$value,
              }}
            >
              {cac}
            </Box>
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: spacing.Spacing.xxs.$value }}
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              CPA PV/PV QFTD
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mx: 1,
              }}
            >
              {cpaPV} / {qftd}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent="flex-start"
            sx={{ width: spacing.Spacing["9xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: 1,
              }}
            >
              ROI
            </Typography>
            <Chip
              label={roiPercentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                bgcolor:
                  roiColor === "success"
                    ? colors.Success[50].$value
                    : roiColor === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  roiColor === "success"
                    ? colors.Success[600].$value
                    : roiColor === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              EPC Click In
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mx: 1,
              }}
            >
              {ClickIn}
            </Typography>
          </Box>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent="flex-start"
            sx={{ width: spacing.Spacing["9xl"].$value }}
          >
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                mr: 1,
              }}
            >
              RS
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Semibold.$value,
                ml: 1,
              }}
            >
              {rs}
            </Typography>
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default BLDWebsitePerformanceCard;
